import { Injectable, inject } from '@angular/core';

import { type Observable } from 'rxjs';
import { WebSessionService } from './web-session.service';

@Injectable({
  providedIn: 'root',
})
export class WebSessionResolver {
  private session = inject(WebSessionService);

  // the difference between this resolver and web-session.guard is that this will allow
  // user to pass, even if there is no session (for public pages)
  resolve(): Observable<boolean> {
    return this.session.tryAccessToken();
  }
}
